import React from 'react';
import { FaBook, FaTools, FaIdCard, FaAward } from 'react-icons/fa';
import '../../../../assets/css/user/about/split/Split.css';
import split1Img from '../../../../assets/images/home/split1.jpg';

const Split = () => {
  return (
    <section className="split-section">
      <div className="row g-0">
        <div
          className="col-lg-6 split-left"
          style={{ backgroundImage: `url(${split1Img})` }}
        >
          <div className="split-content">
            <h2 className="split-title">Committed To Keep Farmers Productive & Safe</h2>
            <p className="split-text">
              We ensure reliable agricultural equipment rental and maintenance services with strict quality checks and safety standards. Our mission is to help farmers work efficiently by providing well-maintained machinery that reduces downtime and increases productivity.
            </p>
          </div>
        </div>

        <div className="col-lg-6 split-right">
          <div className="split-content-right">
            <h2 className="split-title-right">WE ARE THE BEST IN AGRICULTURAL EQUIPMENT SERVICES</h2>
            <p className="split-text-right">
              SmartAgri Rent delivers trusted equipment rental and maintenance solutions with a focus on quality, reliability, and customer satisfaction. We ensure farmers get the right machinery at the right time for maximum efficiency.
            </p>

            <div className="row mt-4">
              <div className="col-6 mb-3">
                <div className="feature-item">
                  <FaBook className="feature-icon" />
                  <span className="feature-text">Reliable Equipment Rental</span>
                </div>
              </div>
              <div className="col-6 mb-3">
                <div className="feature-item">
                  <FaTools className="feature-icon" />
                  <span className="feature-text">Expert Maintenance Service</span>
                </div>
              </div>
              <div className="col-6 mb-3">
                <div className="feature-item">
                  <FaIdCard className="feature-icon" />
                  <span className="feature-text">Skilled Agricultural Team</span>
                </div>
              </div>
              <div className="col-6 mb-3">
                <div className="feature-item">
                  <FaAward className="feature-icon" />
                  <span className="feature-text">Trusted & Certified Quality</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Split;